export default {
    'bond-no': 'رقم السند',
    add: 'إضافة',
    delete: 'حذف',
    'bond-date': 'تاريخ السند',
    'create-bond': 'إضافة منتج',
    edit: 'تعديل',
    save: 'حفظ',

    not: 'غير',
    posted: 'مُرحّل',

    'total-costs': 'مجموع التكاليف: ',
    'create-manufacturing-bond': 'إضافة سند تصنيع',
    'manufacturing-bond-date': 'تاريخ سند تصنيع',
    
    create: 'إنشاء',
    cancel: 'إلغاء',

    'delete-entry': 'حذف قيد',
    'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف القيد؟',

    'delete-journal': 'حذف اليومية',
    'are-you-sure-you-want-to-delete-the-journal': 'هل أنت متأكد من حذف اليومية؟',

    'context-menu': {
        'show-details': 'عرض التفاصيل',
        edit: 'تعديل',
        delete: 'حذف',
    },

    headers: {
        'no': 'رقم',
        'warehouse': 'المستودع',
        'material-name': 'اسم المادة',
        'count': 'العدد',
        'produced-quantity': 'الكمية المنتجة',
        'unit': 'الواحدة',
        'loss-ratio': 'نسبة الخياس',
        'cost-of-one': 'تكلفة الواحدة',
        'total-cost': 'إجمالي الكلفة',
    }
}